module.exports = __webpack_public_path__ + "img/Navigate nextsaina.c96860fc.svg";